export const requestFormClickTypes = {
    OPEN_REQUEST: 'New Request: Educator',
    EDIT_REQUEST: 'Edit Request: Educator',
};

export const requestFormClickNames = {
    DRAFTING_REQUEST: 'Save Draft',
    PUBLISHING_REQUEST: 'Submit Request',
    STEP_FORWARD: (step) => `Completed step ${step} of 3`,
    STEP_BACKWARD: (step) => `Returned to step ${step} of 3`,
};

export const requestTemplateClickTypes = {
    TEMPLATE_USED: 'Request Template Card',
};

export const requestTemplateClickNames = {
    TEMPLATE_USED: 'Customize Request Template',
};
